/**
 * Modelos para la API REST de tracking
 * Migración de GraphQL a REST
 */

export interface CreateSessionRequest {
  cardNumber: number;
  email: string;
  enrollUser?: { email: string } | null;
  recovery?: boolean;
  lastStepReached?: string;
}

export interface SessionResponseDto {
  uid: string;
  trackingToken: string;
  sessionId: string;
  initialDate: number;
  status: string;
}

export interface UpdateEventRequest {
  uid: string;
  cardNumber: number;
  lastStepReached: string;
  eventType: string;
  eventData?: Record<string, unknown>;
  timestamp?: number;
}

export interface PaymentSelectionRequest {
  uid: string;
  cardNumber: number;
  lastStepReached: string;
  paymentMethod: string;
  promotionData: {
    amount: number;
    bonusAmount: number;
    tickets: number;
    token: number;
    bonusToken: number;
  };
  enrollStatus?: boolean;
  email?: string;
}

export interface PendingPaymentRequest {
  uid: string;
  cardNumber: number;
  lastStepReached: string;
  eventType: string;
  paymentMethod: string;
  transactionId?: string; // Opcional: ID de transacción del proveedor de pago
}

export interface PendingPaymentResponse {
  success: boolean;
  transactionId: string;
}

export interface PaymentWebhookDto {
  trackingToken: string;
  provider: string;
  transactionId: string;
  status: string;
  timestamp: number;
  providerData: Record<string, unknown>;
}

export interface WebhookResponseDto {
  received: boolean;
  processed: boolean;
  trackingToken: string;
  message?: string;
}

export interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data?: T;
}
